import { logEvent as firebaseLogEvent } from 'firebase/analytics'

export const logEvent = firebaseLogEvent
